import { useState } from 'react'
import { getLoginItem, getAttributeValue, setAttributeValue, setLoginItem } from '../../utils'
import { Form, FormGroup, Input, Label, Button, Alert } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { SET_USER_ATTRIBUTE_MUTATION, REGISTER_AUTH_APP_MUTATION, GET_QR_CODE_QUERY } from '../../graphql'
import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { ATTRIBUTE_NAME } from '../../constants'
import QRCode from './QRCode'
import { BsQrCodeScan } from 'react-icons/bs'

const SET_USER_ATTRIBUTE = gql(SET_USER_ATTRIBUTE_MUTATION)
const REGISTER_AUTH_APP = gql(REGISTER_AUTH_APP_MUTATION)
const GET_QR_CODE = gql(GET_QR_CODE_QUERY)

export default function TwoFactorAuthentication() {
  console.log('TwoFactorAuthentication rendered')

  const email = getLoginItem('email')
  const cellPhone = getLoginItem('cellPhone')
  const userId = getLoginItem('id')
  const hasSecret = getLoginItem('hasSecret')
  const method = getAttributeValue('MFA Method')
  const { inputs, handleInputChange } = useForm({ email: '', sms: '', app: '' }, handleSubmit)
  const [setUserAttribute] = useMutation(SET_USER_ATTRIBUTE)
  const [registerAuthApp] = useMutation(REGISTER_AUTH_APP)
  const [attributeError, setAttributeError] = useState()
  const [QRCodeComponent, setQRCodeComponent] = useState()
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  async function handleSubmit() {
    console.log('TwoFactorAuthentication.handleSubmit: ', inputs)
  }

  async function handleRadioClick(e) {
    console.log('TwoFactorAuthentication.handleRadioClick')
    const method = e.target.value
    try {
      const result = await setUserAttribute({ variables: { attributeName: ATTRIBUTE_NAME.mfaMethod, attributeValue: method} })
      console.log('result: ', result)
      handleInputChange(e)
      setAttributeError(null)
      setAttributeValue(ATTRIBUTE_NAME.mfaMethod, method)
    } catch(err) {
      e.preventDefault()
      console.log('err: ', err)
      setAttributeError(`An error occurred while updating the "MFA Method" setting: ${err.message}`)
    }
  }

  async function handleRegisterButtonClicked(e) {
    console.log('TwoFactorAuthentication.handleRegisterButtonClicked')
    e.preventDefault()
    try {
      const result = await registerAuthApp()
      console.log('result: ', result)
      if (result.data.registerAuthApp.qr) {
        const qr = result.data.registerAuthApp.qr
        console.log('qrCode: ', qr)
        setLoginItem('hasSecret', true)
        setQRCodeComponent(<QRCode userId={userId} qrCode={qr} modal={true} toggle={toggle} setQRCodeComponent={setQRCodeComponent} />)
      }
    } catch(err) {
      console.log('err: ', err)
      setAttributeError(`An error occurred while retrieving the QR code: ${err.message}`)
    }
  }

  async function handleShowQRButtonClicked(e) {
    console.log('TwoFactorAuthentication.handleShowQRButtonClicked')
    e.preventDefault()
    const { data } = await window.apolloClient.query({ query: GET_QR_CODE })
    if (data.getQRCode) {
      setQRCodeComponent(<QRCode userId={userId} qrCode={data.getQRCode} modal={true} toggle={toggle} setQRCodeComponent={setQRCodeComponent} />)
    }
  }

  let authAppButton = ''
  if (method === 'APP') {
    if (!hasSecret) {
      authAppButton = 
      <Button onClick={handleRegisterButtonClicked} size="sm" color="secondary">
        <BsQrCodeScan style={{ width: '1.25rem', height: '1.25rem' }} /> Register account
      </Button>
    } else {
      authAppButton = 
      <Button onClick={handleShowQRButtonClicked} size="sm" color="secondary">
        <BsQrCodeScan style={{ width: '1.25rem', height: '1.25rem' }} /> My Account QR Code
      </Button>
    }
  }
  let errorAlert = attributeError ? <Alert color="danger">{attributeError}</Alert> : ''

  return (
    <div style={{ padding: '20px', backgroundColor: '#F0F2F5', height: '100%' }}>
      {QRCodeComponent}
      <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>Two-factor Authentication</span>
      <Form style={{ paddingTop: '20px', maxWidth: '400px' }}>
        {errorAlert}
        <FormGroup tag="fieldset">
          <legend style={{ fontSize: '1.25rem' }}>Verification Method</legend>
          <FormGroup check>
            <Input 
              defaultChecked={ method === 'EMAIL' ? true : false }
              type="radio"
              name="method"
              value="EMAIL"
              onChange={handleRadioClick} />
            {' '}
            <Label check>{`Email (${email})`}</Label>
          </FormGroup>
          <FormGroup check disabled={cellPhone ? false : true}>
            <Input 
              defaultChecked={ method === 'SMS' ? true : false }
              disabled={cellPhone ? false : true}
              type="radio"
              name="method"
              value="SMS"
              onChange={handleRadioClick} />
            {' '}
            <Label check>{`SMS (${cellPhone ? cellPhone : 'requires cell phone number'})`}</Label>
          </FormGroup>
          <div style={{ verticalAlign: 'bottom' }}>
            <FormGroup check style={{ display: 'inline-block'}}>
              <Input
                defaultChecked={ method === 'APP' ? true : false }
                type="radio"
                name="method"
                value="APP"
                onChange={handleRadioClick} />
              <Label check>{'Authenticator Application'}</Label>
            </FormGroup>
            {' '}
            {authAppButton}
          </div>
        </FormGroup>
      </Form>
    </div>
  )
}
